type CatalogIdentity = { id?: unknown; type?: unknown; _originalId?: unknown };

/** CMS IDs are unique within a collection, not across the combined catalogue. */
export function uniqueCatalogItems<T extends CatalogIdentity>(items: T[]): T[] {
  const seen = new Set<string>();
  return items.filter(item => {
    // Client-fetched pages decorate id; retain the same identity as server data.
    const key = JSON.stringify([item.type, String(item._originalId ?? item.id)]);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
